import { Resolver } from '@urql/exchange-graphcache';
import {
    ChoiceItem,
    SingleChoiceBlock,
    MultipleChoiceBlock,
} from '~/types/graphql';

export interface ChoicesResolverResult extends ChoiceItem {
    /**
     * Internal cache key generated in the choices resolver to ensure choices
     * have unique ids
     */
    __customCacheId?: string;
}

/**
 * Establish unique IDs for choices.
 * Can then be added to the `keys.ChoiceItem` of the cacheExchance as custom cache key.
 */
export const choicesResolver: Resolver = (
    parent: MultipleChoiceBlock | SingleChoiceBlock,
    args,
    cache
) => {
    // @ts-ignore
    const blockKey = cache.keyOfEntity(parent);
    const choiceRefs = cache.resolve(blockKey, 'choices') as string[];

    if (!choiceRefs) {
        return undefined;
    }

    return choiceRefs.map((ref) => {
        if (!ref) {
            return null;
        }

        const choice: ChoiceItem & {
            __customCacheId?: string;
        } = {
            __typename: null,
            id: null,
            value: null,
        };

        for (const key of ['__typename', 'id', 'value']) {
            choice[key] = cache.resolve(ref, key);
        }

        choice.__customCacheId = `${parent.id}:ChoiceItem:${choice.id}`;

        return choice;
    });
};
